import React from "react";
import { useSite } from "@/context/SiteContext";
import { PageHero } from "@/components/PageHero";

const CONTENT = {
  mentions: {
    overline: "Informations légales",
    title: "Mentions légales",
    blocks: [
      ["Éditeur du site", "SHRAL’AUTO — SASU. Siège social : 47, rue Vivienne, 75002 Paris. Contact : {email} — {phone}."],
      ["Immatriculation", "R.C.S. Paris — SIREN : 994 567 121."],
      ["Directeur de la publication", "Jason Pinguaud."],
      ["Atelier / Interventions", "Les interventions sont réalisées à l’atelier de Beaucourt (90500)."],
      ["Activités", "Électronique automobile, diagnostic, reprogrammation moteur, clonage et réparation d’ECU/modules, codage de clés, vente de pièces détachées."],
      ["Hébergement", "Le site est hébergé par Emergent."],
      ["Propriété intellectuelle", "L’ensemble des éléments du site (textes, logo, visuels, mise en page) est la propriété de SHRAL’AUTO. Toute reproduction sans autorisation est interdite."],
    ],
  },
  privacy: {
    overline: "Vos données",
    title: "Politique de confidentialité",
    blocks: [
      ["Données collectées", "Lors d’une prise de rendez-vous ou d’un avis, nous collectons : nom, prénom, téléphone, e-mail, informations du véhicule (marque, modèle, année, immatriculation, kilométrage) et description de la demande."],
      ["Finalité", "Ces données servent uniquement à traiter votre demande de rendez-vous ou d’intervention et à vous contacter à ce sujet. Elles ne sont ni vendues ni cédées à des tiers."],
      ["Conservation", "Les données sont conservées le temps nécessaire au suivi de votre dossier d’atelier."],
      ["Vos droits", "Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, d’opposition et de suppression de vos données. Pour l’exercer, écrivez à {email}."],
      ["Cookies", "Le site n’utilise pas de cookies publicitaires. Seuls des cookies techniques strictement nécessaires au fonctionnement peuvent être utilisés."],
    ],
  },
  cgv: {
    overline: "Conditions",
    title: "Conditions générales",
    blocks: [
      ["Objet", "Les présentes conditions régissent les prestations d’électronique automobile réalisées par SHRAL’AUTO : diagnostic, reprogrammation moteur, clonage et réparation d’ECU/modules, codage de clés et vente de pièces détachées."],
      ["Tarifs", "{tarifs_note} Les tarifs sont exprimés en euros. Les pièces peuvent faire l’objet d’une facturation complémentaire."],
      ["Rendez-vous", "La réservation en ligne bloque la durée d’atelier correspondant à la prestation choisie. Tout rendez-vous peut être modifié ou annulé depuis la page « Mon rendez-vous », dans un délai raisonnable avant la date prévue."],
      ["Diagnostic", "La recherche de panne (30 €) fait office d’estimation : après diagnostic, le montant des travaux et des pièces vous est communiqué. Les travaux ne sont engagés qu’après accord du client."],
      ["Reprogrammation", "{repro_legal}"],
      ["Paiement", "Le règlement s’effectue à la restitution du véhicule, selon les moyens de paiement acceptés par le garage."],
    ],
  },
};

export default function Legal({ kind }) {
  const { settings } = useSite();
  const s = settings || {};
  const c = CONTENT[kind];
  const fill = (t) =>
    t.replace("{address}", s.address || "").replace("{email}", s.email || "")
      .replace("{phone}", s.phone || "").replace("{tarifs_note}", s.tarifs_note || "")
      .replace("{repro_legal}", s.repro_legal || "");

  return (
    <div data-testid={`legal-${kind}`}>
      <PageHero overline={c.overline} title={c.title} />
      <section className="mx-auto max-w-3xl px-4 md:px-8 py-14 space-y-8">
        {c.blocks.map(([title, text]) => (
          <div key={title} className="border-l-2 border-sared pl-6">
            <h2 className="text-2xl text-white">{title}</h2>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{fill(text)}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
